import { render } from "./Unicon.vue?vue&type=template&id=1afb63c2&scoped=true"
import script from "./Unicon.vue?vue&type=script&lang=js"
export * from "./Unicon.vue?vue&type=script&lang=js"

import "./Unicon.vue?vue&type=style&index=0&id=1afb63c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afb63c2"],['__file',"src/components/Unicon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1afb63c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1afb63c2', __exports__)) {
    api.reload('1afb63c2', __exports__)
  }
  
  module.hot.accept("./Unicon.vue?vue&type=template&id=1afb63c2&scoped=true", () => {
    api.rerender('1afb63c2', render)
  })

}


export default __exports__